export default __webpack_public_path__ + "static/media/filter.659a7e13.svg";